export class CompanyData {
    constructor() {}

    Address: string;
    City: string;
    CompanyAccount: string;
    CompanyAccountBankCode: string;
    CompanyAccountControlNumber: string;
    CompanyAccountNumber: string;
    Email: string;
    Fax: string;
    Name: string;
    NationalIdentificationNumber: string;
    Phone: string;
    Phone2: string;
    PostalCode: string;
    ShortName: string;
    TaxIdentificationNumber: string;
    Web: string;
    AccountNumbers: string[];

    Deserialize(input: any){
        this.Address = input.Address;
        this.City = input.City;
        this.CompanyAccount = input.CompanyAccount;
        this.CompanyAccountBankCode = input.CompanyAccountBankCode;
        this.CompanyAccountControlNumber = input.CompanyAccountControlNumber;
        this.CompanyAccountNumber = input.CompanyAccountNumber;
        this.Email = input.Email;
        this.Fax = input.Fax;
        this.Name = input.Name;
        this.NationalIdentificationNumber = input.NationalIdentificationNumber;
        this.Phone = input.Phone;
        this.Phone2 = input.Phone2;
        this.PostalCode = input.PostalCode;
        this.ShortName = input.ShortName;
        this.TaxIdentificationNumber = input.TaxIdentificationNumber;
        this.Web = input.Web;
        this.AccountNumbers = input.AccountNumbers || [];
        return this;
    }
}